import { ROUTES } from '@/shared/constants/routes';

// A backend-supplied notification link may only navigate to known in-app
// routes. Anything else is ignored rather than followed.
// Whole path segments only (a plain prefix let "/administrator" through on
// "/admin"), and no routes with parameters (the public /approve/:token page).
const SAFE_LINK_ROUTES: readonly string[] = (Object.values(ROUTES) as string[]).filter(
  (r) => r.startsWith('/') && r !== '/' && !r.includes(':'),
);

export function isSafeNotificationLink(link: string | null | undefined): link is string {
  if (!link || !link.startsWith('/') || link.startsWith('//')) return false;
  return SAFE_LINK_ROUTES.some((r) => link === r || ['/', '?', '#'].some((sep) => link.startsWith(r + sep)));
}
